import * as React from "react";
import tw, { styled } from "twin.macro";

import InputField from "./InputField";
import Button from "./Button";
import { CreateChargePayload } from "app/api/charge/type";
import useClickAway from "app/hooks/useClickAway";
import // AppStateActions,
  "app/providers/AppStateProvider";
import useIntializePayment from "app/hooks/useInitializePayment";
import {
  AppStateActions,
  useAppDispatch,
  useAppState,
} from "app/providers/AppStateProvider";
import { PaymentCharge } from "app/models/charge";
import { SourceType } from "app/providers/types";

export default function DevModeWidget() {
  const [isOpen, setIsOpen] = React.useState(false);

  const toggle = () => {
    setIsOpen((o) => !o);
  };
  const close = () => {
    setIsOpen(false);
  };
  const ref = useClickAway(close);

  const { merchant, source, sourceId } = useAppState();

  const dispatch = useAppDispatch();

  const [state, setState] = React.useState<PaymentCharge & { source?: SourceType; sourceId?: string }>(() => ({ ...merchant!, source, sourceId }));

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setState((s) => ({ ...s, [name]: value }));
  };

  // const { isLoading } = useCreateCharge();

  const { isLoading, intializePayment } = useIntializePayment();

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { name, email, quote_amount, source, sourceId, ...rest } = state;



    const data: CreateChargePayload = {
      ...rest,
      local_amount: quote_amount!,
      local_currency: state.quote_currency!,
      meta: { name, email },
    };

    intializePayment(data, {
      onSuccess() {
        dispatch({
          type: AppStateActions.setAppState,
          payload: {
            merchant: {
              ...merchant,
              public_key: state.public_key,
              quote_currency: state.quote_currency,
              quote_amount: state.quote_amount,
              target_currency: state.target_currency,
              source_currency: state.source_currency,
              meta: {
                name: name ?? "",
                email: email ?? "",
              },
            },
            source: source,
            sourceId: sourceId,
          },
        });
      }
    });

    // if (callback_url) data.callback_url = callback_url;

    // createCharge(data);
  };

  return (
    <Container>
      <button
        aria-label="Open"
        type="button"
        tw="text-[4rem] border border-border rounded-lg p-3"
        onClick={toggle}
      >
        🛠
      </button>

      {isOpen && (
        <Dropdown ref={ref}>
          <form
            onSubmit={handleSubmit}
            tw="overflow-y-auto h-[calc(100vh - 150px)]!"
          >
            <InputField
              label="Public Key"
              name="public_key"
              value={state.public_key}
              required
              onChange={handleChange}
            />

            <InputField
              label="Customer Name"
              name="name"
              value={state.name}
              onChange={handleChange}
              required
            />

            <InputField
              label="Customer Email"
              name="email"
              value={state.email}
              onChange={handleChange}
              required
            />

            <InputField
              label="Target Currency"
              name="target_currency"
              value={state.target_currency}
              onChange={handleChange}
              required
            />

            <InputField
              label="Source Currency"
              name="source_currency"
              value={state.source_currency}
              onChange={handleChange}
              required
            />

            <InputField
              label="Quote Currency"
              name="quote_currency"
              value={state.quote_currency}
              onChange={handleChange}
              required
            />

            <InputField
              label="Quote Amount"
              name="quote_amount"
              value={state.quote_amount}
              onChange={handleChange}
              required
            />

            <InputField
              label="Source"
              name="source"
              placeholder="payment-request or payment-link"
              value={state.source}
              onChange={handleChange}
            />

            <InputField
              label="Source ID"
              name="sourceId"
              value={state.sourceId}
              onChange={handleChange}
            />

            <Button
              variant="secondary"
              fullWidth
              text="Create Charge"
              tw="mt-[15px] flex-shrink-0"
              loading={isLoading}
            />
          </form>
        </Dropdown>
      )}
    </Container>
  );
}

const Container = styled.div`
  ${tw`fixed top-0 left-0 p-[16px]`};
`;

const Dropdown = styled.div`
  ${tw`bg-white mt-[5px] rounded-xl absolute top-full min-h-[100px] mobile:h-[75vh] w-[240px] border border-border shadow-sm p-[10px] overflow-y-auto`};

  form {
    ${tw`h-full flex flex-col gap-[10px]`};

    label {
      ${tw`text-[1.2rem]`};
    }

    input {
      ${tw`h-[45px] text-[1.4rem]`};
    }
  }
`;
